var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 350,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2b36276827"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.035156 67.359375 L 112.6875 67.359375 L 112.6875 286.34375 L 12.035156 286.34375 Z M 12.035156 67.359375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ed7090e9d3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 85.863281 67.359375 L 85.863281 242.382812 L 112.40625 242.382812 L 112.40625 286.34375 L 56.414062 286.34375 L 12.035156 241.964844 L 12.035156 67.359375 Z M 85.863281 67.359375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "226412f43d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0351562 0.359375 L 100.558594 0.359375 L 100.558594 219.34375 L 0.0351562 219.34375 Z M 0.0351562 0.359375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ebd0f9aa3b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.863281 0.359375 L 73.863281 175.382812 L 100.40625 175.382812 L 100.40625 219.34375 L 44.414062 219.34375 L 0.0351562 174.964844 L 0.0351562 0.359375 Z M 73.863281 0.359375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "129277c919"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 101,
    y: 0,
    height: 220
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "386ca45320"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 120.699219 66.527344 L 224.707031 66.527344 L 224.707031 288.027344 L 120.699219 288.027344 Z M 120.699219 66.527344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1f93240ddb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 224.386719 66.527344 L 224.386719 288.003906 L 120.699219 288.003906 L 120.699219 243.210938 L 150.5625 242.382812 L 150.5625 67.773438 C 150.5625 67.6875 151.714844 66.527344 151.804688 66.527344 Z M 224.386719 66.527344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9873bb668b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.699219 0.527344 L 104.398438 0.527344 L 104.398438 222.027344 L 0.699219 222.027344 Z M 0.699219 0.527344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6024ad6663"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 104.386719 0.527344 L 104.386719 222.003906 L 0.699219 222.003906 L 0.699219 177.210938 L 30.5625 176.382812 L 30.5625 1.773438 C 30.5625 1.6875 31.714844 0.527344 31.804688 0.527344 Z M 104.386719 0.527344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7fba30addf"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 105,
    y: 0,
    height: 223
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "92d889290f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 236 66.527344 L 363 66.527344 L 363 285.742188 L 236 285.742188 Z M 236 66.527344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d09d139816"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 236 285.511719 L 236 241.550781 L 289.917969 241.550781 L 289.917969 110.492188 L 236 110.492188 L 236 66.527344 L 318.535156 66.527344 L 362.746094 111.074219 L 362.964844 239.527344 L 362.128906 242.839844 L 318.535156 285.511719 Z M 236 285.511719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5cceab4452"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0.527344 L 127 0.527344 L 127 219.601562 L 0 219.601562 Z M 0 0.527344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "18ea602a04"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 219.511719 L 0 175.550781 L 53.917969 175.550781 L 53.917969 44.492188 L 0 44.492188 L 0 0.527344 L 82.535156 0.527344 L 126.746094 45.074219 L 126.964844 173.527344 L 126.128906 176.839844 L 82.535156 219.511719 Z M 0 219.511719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6e4edec515"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 127,
    y: 0,
    height: 220
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2b36276827)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ed7090e9d3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 12, 67)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#129277c919)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#226412f43d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ebd0f9aa3b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#644672",
    d: "M 0.0351562 0.359375 L 100.363281 0.359375 L 100.363281 219.34375 L 0.0351562 219.34375 Z M 0.0351562 0.359375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#386ca45320)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1f93240ddb)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 120, 66)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7fba30addf)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9873bb668b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6024ad6663)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#433f56",
    d: "M 0.699219 0.527344 L 104.386719 0.527344 L 104.386719 222.027344 L 0.699219 222.027344 Z M 0.699219 0.527344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#92d889290f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d09d139816)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 236, 66)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6e4edec515)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5cceab4452)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#18ea602a04)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#433f56",
    d: "M 0 0.527344 L 126.964844 0.527344 L 126.964844 219.417969 L 0 219.417969 Z M 0 0.527344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6df36278fa57bf53a747fca01592bad6.svg";
export { ForwardRef as ReactComponent };